"use client";
import { jsxs as B, jsx as m } from "react/jsx-runtime";
import { ellipsis as k } from "../../common/styles/mixins/ellipsis.js";
import I from "../icon-button/IconButton.js";
import h from "../icon/Icon.js";
import { css as s } from "@emotion/react";
import d from "@emotion/styled";
import { opacity as n } from "../../helpers/color/color.js";
import { COLORS as r } from "../../tokens/colors/Colors.js";
import { FONT_SIZES as b } from "../../tokens/font-sizes/FontSizes.js";
import { SIZES as i } from "../../tokens/sizes/Sizes.js";
import { SPACINGS as l } from "../../tokens/spacings/Spacings.js";
import { forwardRef as w } from "react";
const $ = w(
  ({
    children: o,
    feClosable: e,
    feColor: t,
    feDisabled: a = !1,
    feIcon: p,
    feIconColor: y,
    feSize: c = "md",
    feType: u = "filled",
    ...x
  }, S) => /* @__PURE__ */ B(
    f,
    {
      ...x,
      "data-comp": "tag",
      feColor: t,
      feDisabled: a,
      feSize: c,
      feType: u,
      ref: S,
      children: [
        p && /* @__PURE__ */ m(
          O,
          {
            feColor: t || y,
            feDisabled: a,
            feIcon: p,
            feSize: "sm"
          }
        ),
        /* @__PURE__ */ m(T, { children: o }),
        c === "md" && e && /* @__PURE__ */ m(
          j,
          {
            ...e,
            "aria-label": e["aria-label"] ?? `Remove tag: ${o}`,
            as: "button",
            disabled: a,
            feIcon: "close",
            feSize: "sm",
            type: "button"
          }
        )
      ]
    }
  )
);
$.displayName = "Tag";
const q = $, g = Object.freeze({
  blue: {
    bg: n(r.brand, 0.1),
    border: r.brand
  },
  green: {
    bg: n(r.greenBase, 0.1),
    border: r.greenBase
  },
  orange: {
    bg: n(r.orangeDark, 0.1),
    border: r.orangeDark
  },
  purple: {
    bg: n(r.purpleBase, 0.1),
    border: r.purpleBase
  },
  red: {
    bg: n(r.redBase, 0.1),
    border: r.redBase
  },
  yellow: {
    bg: n(r.yellowDarker, 0.1),
    border: r.yellowDarker
  }
}), f = d.div(
  ({
    feColor: o,
    feDisabled: e,
    feSize: t,
    feType: a
  }) => s`
		align-items: center;
		color: ${e && r.gray500};
		display: inline-flex;
		max-width: 48ch;
		padding: 0 ${l.xs};

		${t === "md" && s`
			border-radius: ${i.s08};
			font-size: ${b.xs};
			height: ${i.s28};
		`}

		${t === "sm" && s`
			border-radius: ${i.s06};
			font-size: ${b.xxs};
			height: ${i.s20};
		`}

		${a === "filled" && s`
			background-color: ${o && !e ? g[o].bg : e ? r.gray100 : r.gray200};
		`}

		${a === "outlined" && s`
			background-color: ${o && !e ? g[o].bg : e && r.gray050};
			/* stylelint-disable-next-line declaration-property-value-no-unknown */
			border: 1px solid
				${o && !e ? g[o].border : e ? r.gray500 : r.gray600};
		`}
	`
), T = d.span`
	${k()}
`, O = d(h)(
  ({ feDisabled: o }) => s`
		color: ${o && r.gray500};
		margin-inline-end: ${l.xxs};
	`
), j = d(I)`
	margin-inline-start: ${l.xs};
`;
export {
  q as default
};
